import { render, staticRenderFns } from "./PrestamoAplicado.vue?vue&type=template&id=066bc620&scoped=true"
import script from "./PrestamoAplicado.vue?vue&type=script&lang=js"
export * from "./PrestamoAplicado.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./PrestamoAplicado.vue?vue&type=style&index=2&id=066bc620&prod&lang=css"
import style3 from "./PrestamoAplicado.vue?vue&type=style&index=3&id=066bc620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066bc620",
  null
  
)

export default component.exports